// extracted by mini-css-extract-plugin
module.exports = {"reveal":"Reveal_reveal__lPMRy","visible":"Reveal_visible__A4Z6T"};